import styles from "./RouterBanner.module.css";
import {NavLink} from "react-router-dom";
import CasinoPng from "./images/casinoBanner.png";
import UserStore from "../../../store/user-store";

export const CasinoBanner = () => {
    return (
        <div className={styles.banner}>
            <div className={styles.content} style={{gap: 0}}>
                <div className={styles.text}>
                    <h1>{UserStore.langCode === 'ru' ? "Крути рулетку - получи VPN!" : "Spin the roulette wheel - get a VPN!"}</h1>
                    {UserStore.langCode === 'ru' ? <p>Может, именно ты <br/> выиграешь Lifetime Pass! </p> : <p>You might be the one <br/> to win a Lifetime Pass!</p>}
                </div>
                <NavLink style={{background: "white", color: "black", opacity: 0.5}}>{UserStore.langCode === 'ru' ? "Скоро" : "Soon"}</NavLink>
            </div>
            <img
                src={CasinoPng}
                alt="Casino Banner"
                style={{position: "absolute", right: 0, top: -12, zIndex: 10}}
            />
        </div>
    )
}
